import React, { useCallback, useContext, useMemo }  from 'react'
import { Accordion,AccordionItem } from '../../../commonComponents/accordion';
import { Exporter,Importer,Declarant, Buyer, Seller, Representative,Consignee,Carrier } from './Actors';
import ActorProvider from './Actors/actorProvider'
import ActorDetailHeader from './actorDetailHeader';
import Authorization from "./authorization"
import Guarantee from './guarantee'
import SupplyChainActor from './supplyChainActor';
import FiscalReferences from './fiscalReferences';
import DeferredPayment from './deferredPayment'
import EidrEori from './EidrEori'
import CopyActorLogic from './CopyActorLogic';
import  CustomTooltip  from '../../../commonComponents/customTooltip';
import { Checkbox } from 'semantic-ui-react';
import ErrorMessagesWindow from '@commonComponents/errorValidationWindow';
import { useSelector } from 'react-redux';
import { useCurrentShipmentType } from '../../../hooks/useCurrentShipmentType';
import ActorDetailForm from "../../../commonComponents/formComponents/actorDetailForm";
import { ActorContext } from './Actors/actorProvider';
import PartiesTabError from '../../../NL_App/formSections/partiesTab/Actors/PartiesTabError';






const initialiExpandedState={'exporter':true,'importer':true,'consignee':true}

const PartiesForm =(props) => {
  const { isFormEnabled,translate} = props;
  const isFormDisabled = isFormEnabled === false;
  const ErrorWarningsList = useSelector((state) => state.ErrorValidationReducer?.partiesTab) || []

  const {serviceType} = useCurrentShipmentType()

  const actorDetails=useContext(ActorContext)
  const {savePartiesActorDetails} = actorDetails

 


  const actorDetailForm = (params) => {
const {roleId}=params.dataSource
 const saveActorDetails = useCallback((params,key) =>{
  params.roleId = roleId
  savePartiesActorDetails(params,key)
  },[roleId])
    return (
      <PartiesTabError actorType={params?.actorType}>
    {(errorInfo)=><ActorDetailForm 
              {...params} 
              {...actorDetails}
              saveActorDetails ={saveActorDetails}
              errorInfo={errorInfo}
             ></ActorDetailForm>}
             </PartiesTabError>
             )
  }

  return (
    <div className='parties formContentareaC88'>
      {!props?.isServerErrorsCommon && ErrorWarningsList?.length > 0 && !props.disabled && (
        <ErrorMessagesWindow errors={ErrorWarningsList} />
      )}

      <Accordion translate={translate} initialiState={initialiExpandedState}>
        <AccordionItem
          idText={'exporterShow'}
          rightHeader={
            <CopyActorLogic
              actorType='exporter'
              renderProps={({ copiedActorStatus, copyActorDetails }) => {
                return (
                  <CustomTooltip btnId={'copyTo'} className='copyTo' title='COPY TO'>
                    <div className='copyToContainer'>
                      {Object.entries(copiedActorStatus).map(([key, value]) => {
                        return (
                          <Checkbox
                            id={`copyTo${key}`}
                            checked={value}
                            name={key}
                            onChange={copyActorDetails}
                            label={<label>{key.toUpperCase()}</label>}
                          />
                        )
                      })}
                    </div>
                  </CustomTooltip>
                )
              }}
            ></CopyActorLogic>
          }
          id='exporter'
          translate={translate}
          title={(props) => (
            <ActorDetailHeader
              title='Exporter'
              actorType='exporter'
              boxNumber='3/1'
              {...props}
            ></ActorDetailHeader>
          )}
        >
          <Exporter renderForm={actorDetailForm} />
        </AccordionItem>
        {serviceType === 'IM' && (
          <AccordionItem
            idText='importerShow'
            id='importer'
            translate={translate}
            title={(props) => (
              <ActorDetailHeader
                title='Importer'
                actorType='importer'
                boxNumber='3/15'
                {...props}
              ></ActorDetailHeader>
            )}
          >
            <Importer renderForm={actorDetailForm} />
          </AccordionItem>
        )}
        {serviceType === 'EX' && (
          <AccordionItem
            idText='consigneeShow'
            id='consignee'
            translate={translate}
            title={(props) => (
              <ActorDetailHeader
                title='Consignee'
                actorType='consignee'
                boxNumber='3/9'
                {...props}
              ></ActorDetailHeader>
            )}
          >
            <Consignee renderForm={actorDetailForm} />
          </AccordionItem>
        )}
        <AccordionItem
          idText='declarantShow'
          id='declarant'
          translate={translate}
          title={(props) => (
            <ActorDetailHeader
              title='Declarant'
              actorType='declarant'
              boxNumber='3/17'
              {...props}
            ></ActorDetailHeader>
          )}
        >
          <Declarant renderForm={actorDetailForm} />
        </AccordionItem>
        <EidrEori />
        {serviceType === 'IM' && (
          <AccordionItem
            idText='sellerShow'
            id='seller'
            translate={translate}
            title={(props) => (
              <ActorDetailHeader
                title='Seller'
                actorType='seller'
                boxNumber='3/24'
                {...props}
              ></ActorDetailHeader>
            )}
          >
            <Seller renderForm={actorDetailForm} />
          </AccordionItem>
        )}
        {serviceType === 'IM' && (
          <AccordionItem
            idText='buyerShow'
            id='buyer'
            translate={translate}
            title={(props) => (
              <ActorDetailHeader
                title='Buyer'
                actorType='buyer'
                boxNumber='3/26'
                {...props}
              ></ActorDetailHeader>
            )}
          >
            <Buyer renderForm={actorDetailForm} />
          </AccordionItem>
        )}
        <AccordionItem
          idText='representativeShow'
          id='representative'
          translate={translate}
          title={(props) => (
            <ActorDetailHeader
              title='Representative'
              actorType='representative'
              boxNumber='3/19'
              {...props}
            ></ActorDetailHeader>
          )}
        >
          <Representative renderForm={actorDetailForm} />
        </AccordionItem>
        {serviceType === 'EX' && (
          <AccordionItem
            idText='carrierShow'
            id='carrier'
            translate={translate}
            title={(props) => (
              <ActorDetailHeader
                title='Carrier'
                actorType='carrier'
                boxNumber='3/31'
                {...props}
              ></ActorDetailHeader>
            )}
          >
            <Carrier renderForm={actorDetailForm} />
          </AccordionItem>
        )}
      </Accordion>
      {serviceType === 'IM' && <DeferredPayment isFormEnabled={isFormEnabled} />}
      <FiscalReferences />
      <Guarantee />
      <Authorization />

      <SupplyChainActor />
    </div>
  )

}

export default React.memo(PartiesForm);